import {
  PaginaDeViajesSchema,
  ResultadoDeCargaDeViajesSchema,
  ViajeSchema,
  type EdicionDeViaje,
  type NuevoViaje,
} from '@cnc/contracts';
import {keepPreviousData, useMutation, useQuery, useQueryClient} from '@tanstack/react-query';
import {pedir} from './cliente';
import {refrescarDatos} from './refrescar';

// Viajes de camion de las recolecciones, con los filtros de la direccion de la pagina.
export function useViajes(parametros: URLSearchParams) {
  const cadena = parametros.toString();
  const direccion = `transporte/viajes${cadena ? `?${cadena}` : ''}`;
  return useQuery({
    queryKey: ['transporte', 'viajes', cadena],
    queryFn: () => pedir(direccion, PaginaDeViajesSchema),
    placeholderData: keepPreviousData,
  });
}

// Excel "para editar" con los mismos filtros (sin paginacion).
export const rutaExcelDeViajes = (parametros: URLSearchParams) => {
  const sinPagina = new URLSearchParams(parametros);
  sinPagina.delete('pagina');
  const cadena = sinPagina.toString();
  return `/api/transporte/viajes/excel${cadena ? `?${cadena}` : ''}`;
};

export function useEditarViaje() {
  const cliente = useQueryClient();
  return useMutation({
    mutationFn: ({id, cuerpo}: {id: number; cuerpo: EdicionDeViaje}) =>
      pedir(`transporte/viajes/${id}`, ViajeSchema, {
        method: 'PATCH',
        headers: {'content-type': 'application/json'},
        body: JSON.stringify(cuerpo),
      }),
    // Tambien ante un choque: la tabla se recarga con los datos de ahora.
    onSettled: () => cliente.invalidateQueries({queryKey: ['transporte']}),
  });
}

export function useCrearViaje() {
  const cliente = useQueryClient();
  return useMutation({
    mutationFn: (cuerpo: NuevoViaje) =>
      pedir('transporte/viajes', ViajeSchema, {
        method: 'POST',
        headers: {'content-type': 'application/json'},
        body: JSON.stringify(cuerpo),
      }),
    onSuccess: () => cliente.invalidateQueries({queryKey: ['transporte']}),
  });
}

export function useCargarExcelDeViajes() {
  const cliente = useQueryClient();
  return useMutation({
    mutationFn: ({archivo, modo}: {archivo: File; modo: 'revisar' | 'aplicar'}) => {
      const cuerpo = new FormData();
      cuerpo.append('archivo', archivo, archivo.name);
      cuerpo.append('modo', modo);
      return pedir('transporte/viajes/excel', ResultadoDeCargaDeViajesSchema, {method: 'POST', body: cuerpo});
    },
    onSuccess: async resultado => {
      if (resultado.aplicado) await refrescarDatos(cliente);
    },
  });
}
